import { render, staticRenderFns } from "./VProfile.vue?vue&type=template&id=461f2e66"
import script from "./VProfile.vue?vue&type=script&lang=ts"
export * from "./VProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports